<button (click)="modal.showModal()" class="info-btn">
  <svg
    width="18"
    height="18"
    class="shrink-0"
    viewBox="0 0 18 18">
    <use class="fill-current" [attr.xlink:href]="SvgSpriteIcon.Information"></use>
  </svg>
</button>

<dialog #modal>
  <div class="content">
    <button (click)="modal.close()" autofocus>
      <svg
        width="24"
        height="24"
        class="shrink-0"
        viewBox="0 0 24 24">
        <use class="fill-current" [attr.xlink:href]="SvgSpriteIcon.Close"></use>
      </svg>
    </button>
    <ng-content/>
  </div>
</dialog>

